/**
 * @generated SignedSource<<39f14c896fd046eb2567ec37148427ae>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type DeletionReason = "AUTO" | "MANUAL";
export type RecapTemplateType = "BANT" | "CUSTOMER_SUCCESS" | "MEDDIC" | "SALES_DISCOVERY" | "SALES_FOLLOW_UP" | "SPICED";
import { FragmentRefs } from "relay-runtime";
export type HighlightsPanel_meetingRecording$data = {
  readonly __typename: "MeetingRecording";
  readonly activeSummary: {
    readonly actionItems: ReadonlyArray<{
      readonly assignees: ReadonlyArray<{
        readonly fullName: string;
        readonly userId: string | null;
      }>;
      readonly edited: boolean | null;
      readonly insertedBlockKey: string | null;
      readonly text: string;
      readonly timestamp: number;
    }> | null;
    readonly activeRecapTemplate?: RecapTemplateType | null;
    readonly chapters: ReadonlyArray<{
      readonly bulletPoints: ReadonlyArray<{
        readonly context: string | null;
        readonly text: string;
        readonly textShort: string | null;
        readonly timestamp: number | null;
      }>;
      readonly timestamp: number | null;
      readonly title: string;
    }> | null;
    readonly createdAt: string;
    readonly decisions: ReadonlyArray<{
      readonly " $fragmentSpreads": FragmentRefs<"HighlightsPanel_DecisionsHighlight_decisions">;
    }> | null;
    readonly summary: string | null;
    readonly templatedRecaps?: any | null;
  } | null;
  readonly hasExternalAttendees?: boolean;
  readonly id: string;
  readonly meetingCallEnd: string | null;
  readonly meetingRecordedVideoDuration: number | null;
  readonly ownerAccount: {
    readonly __typename: string;
  };
  readonly recordingAndTranscriptWillBeDeleted: boolean;
  readonly recordingDataAutoDeletionDate: string | null;
  readonly showLowLanguageConfidenceRegenerationBanner: boolean | null;
  readonly smartTrackers?: ReadonlyArray<{
    readonly matches: ReadonlyArray<{
      readonly endTimestamp: number;
      readonly startTimestamp: number;
    }>;
    readonly trackerName: string;
  }>;
  readonly title: string;
  readonly transcriptDeletionReason: DeletionReason | null;
  readonly userVideoProgress: number;
  readonly " $fragmentSpreads": FragmentRefs<"TranscriptPanel_LowLanguageConfidenceRegenerationBanner_meetingRecording" | "TranscriptPanel_RelabelMultipleSpeakersModal_meetingRecording" | "TranscriptPanel_UnlabeledSpeakersWarning_meetingRecording" | "utils_AddedOrAvailableUntil_meetingRecording">;
  readonly " $fragmentType": "HighlightsPanel_meetingRecording";
};
export type HighlightsPanel_meetingRecording$key = {
  readonly " $data"?: HighlightsPanel_meetingRecording$data;
  readonly " $fragmentSpreads": FragmentRefs<"HighlightsPanel_meetingRecording">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "timestamp",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "text",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v4 = [
  {
    "kind": "Variable",
    "name": "public",
    "variableName": "public"
  }
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "public"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "HighlightsPanel_meetingRecording",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "condition": "public",
      "kind": "Condition",
      "passingValue": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "hasExternalAttendees",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "SmartTrackerResult",
          "kind": "LinkedField",
          "name": "smartTrackers",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "trackerName",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "SmartTrackerMatch",
              "kind": "LinkedField",
              "name": "matches",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startTimestamp",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endTimestamp",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "MeetingRecordingSummary",
      "kind": "LinkedField",
      "name": "activeSummary",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "summary",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "createdAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "TranscriptActionItem",
          "kind": "LinkedField",
          "name": "actionItems",
          "plural": true,
          "selections": [
            (v1/*: any*/),
            (v2/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "TranscriptActionItemAssignee",
              "kind": "LinkedField",
              "name": "assignees",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "userId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "fullName",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "insertedBlockKey",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "edited",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "TranscriptDecision",
          "kind": "LinkedField",
          "name": "decisions",
          "plural": true,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "HighlightsPanel_DecisionsHighlight_decisions"
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "TranscriptChapter",
          "kind": "LinkedField",
          "name": "chapters",
          "plural": true,
          "selections": [
            (v1/*: any*/),
            (v3/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "TranscriptBulletPoint",
              "kind": "LinkedField",
              "name": "bulletPoints",
              "plural": true,
              "selections": [
                (v1/*: any*/),
                (v2/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "textShort",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "context",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "condition": "public",
          "kind": "Condition",
          "passingValue": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "templatedRecaps",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "activeRecapTemplate",
              "storageKey": null
            }
          ]
        }
      ],
      "storageKey": null
    },
    (v3/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "meetingCallEnd",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "recordingAndTranscriptWillBeDeleted",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "transcriptDeletionReason",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "recordingDataAutoDeletionDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "meetingRecordedVideoDuration",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "utils_AddedOrAvailableUntil_meetingRecording"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "userVideoProgress",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "ownerAccount",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "showLowLanguageConfidenceRegenerationBanner",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TranscriptPanel_UnlabeledSpeakersWarning_meetingRecording"
    },
    {
      "args": (v4/*: any*/),
      "kind": "FragmentSpread",
      "name": "TranscriptPanel_RelabelMultipleSpeakersModal_meetingRecording"
    },
    {
      "args": (v4/*: any*/),
      "kind": "FragmentSpread",
      "name": "TranscriptPanel_LowLanguageConfidenceRegenerationBanner_meetingRecording"
    }
  ],
  "type": "MeetingRecording",
  "abstractKey": null
};
})();

(node as any).hash = "d3a891adf311fd2dc0eb64a6dbe3296e";

export default node;
